import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from './authService';

export const adminReviewKeys = {
  all: ['admin-reviews'],
  lists: () => [...adminReviewKeys.all, 'list'],
  list: (filters) => [...adminReviewKeys.lists(), filters],
  stats: () => [...adminReviewKeys.all, 'stats'],
  detail: (id) => [...adminReviewKeys.all, 'detail', id],
};

export const adminReviewApi = {
  getReviews: async (params = {}) => {
    const response = await api.get('/admin/reviews', { params });
    return response.data;
  },
  getStatistics: async () => {
    const response = await api.get('/admin/reviews/statistics');
    return response.data;
  },
  getReview: async (id) => {
    const response = await api.get(`/admin/reviews/${id}`);
    return response.data;
  },
  approve: async (id) => {
    const response = await api.put(`/admin/reviews/${id}/approve`);
    return response.data;
  },
  hide: async (id) => {
    const response = await api.put(`/admin/reviews/${id}/hide`);
    return response.data;
  },
  remove: async (id) => {
    const response = await api.delete(`/admin/reviews/${id}`);
    return response.data;
  },
  bulkApprove: async (ids) => {
    const response = await api.post('/admin/reviews/bulk-approve', { ids });
    return response.data;
  },
};

export const useAdminReviews = (params = {}, options = {}) =>
  useQuery({
    queryKey: adminReviewKeys.list(params),
    queryFn: () => adminReviewApi.getReviews(params),
    keepPreviousData: true,
    ...options,
  });

export const useAdminReviewStatistics = (options = {}) =>
  useQuery({
    queryKey: adminReviewKeys.stats(),
    queryFn: () => adminReviewApi.getStatistics(),
    ...options,
  });

export const useApproveAdminReview = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: adminReviewApi.approve,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminReviewKeys.all });
    },
    ...options,
  });
};

export const useHideAdminReview = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: adminReviewApi.hide,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminReviewKeys.all });
    },
    ...options,
  });
};

export const useDeleteAdminReview = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: adminReviewApi.remove,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminReviewKeys.all });
    },
    ...options,
  });
};

export const useBulkApproveAdminReviews = (options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: adminReviewApi.bulkApprove,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminReviewKeys.all });
    },
    ...options,
  });
};
